import { CloudAccountType, type Account } from '@repo/api-gw-sdk';

import { UpdateAccountRoleGcpInnerPanel } from './updateAccountRoleGcpInnerPanel';

export const UpdateAccountGCPPanel = ({
  account,
  onClose,
  onUpdated,
}: {
  account: Account;
  onClose: () => void;
  onUpdated: () => void;
}) => {
  return (
    <UpdateAccountRoleGcpInnerPanel
      headerTitle='Update permissions'
      accountType={
        account.accountType || CloudAccountType.AccountTypeUnspecified
      }
      onUpdated={onUpdated}
      onClose={onClose}
      initialProjectId={account.providerAccountId}
    />
  );
};
